module.exports = __webpack_public_path__ + "static/Mohamed-Al-Maskari-ede5483dfe77a261ea2efe41f40d8b72.jpg";